<template>
<v-container fluid class="homeBody">

  <div class="labelStuff">
    <div class="logoWithin">
      <div>
        <p class="logoText">Saving App</p>
      </div>
      <div class="bigLogo">
        <img src="../assets/Circled Logo Large.png" alt="Savings App">
      </div>
    </div>
  </div>

    <v-layout column style="height: 100%;" class="first-card">
      <v-flex xs12>
        <div class="resultContainer" style="height: 100%;">
          <v-layout align-center justify-center row fill-height>
             <div class="item">
                <v-card class="welcomeCard">
                <v-card-title primary-title>
                  <v-layout align-center justify-center row >
                  <div>
                  <h3 class="headline title" style="color: white;">Please Login or Signup</h3>
                  </div>
                  </v-layout>
                </v-card-title>
                <v-card-text>
                   <div>
                      <p class="logoText">
                        Savings App
                      </p>
                   </div>
                </v-card-text>
                <v-layout align-center justify-center row >
                <v-card-actions class="actions">

                   <div class="background">
                        &nbsp;
                   </div>
                   <div class="foreground">
                      <v-btn color="white" block flat>
                        <router-link to="/login" tag="span">LOGIN</router-link>
                      </v-btn>
                   </div>

                </v-card-actions>
                </v-layout>

                <v-card-text>
                  <p class="text-xs-center paraLink" style="color: white;">
                    don't have an account with us?
                  </p>
                </v-card-text>

                 <v-card-actions class="actions1">
                    <div class="background1">
                        &nbsp;
                   </div>
                   <div class="foreground1">
                      <v-btn color="white" block flat>
                        <router-link to="/signup" tag="span">SIGN UP</router-link>
                      </v-btn>
                   </div>
                </v-card-actions>

                </v-card>


             </div>
    </v-layout>
        </div>
      </v-flex>

    </v-layout>

</v-container>


</template>

<script>
export default {
  data () {
    return {

    }
  }

}
</script>

<style scoped>

  .homeBody {
    padding: 0;
    background-color: #0055D4;
    height: 100%;
    width: 100%;
    position: relative;
  }

  .labelStuff {
    color: white;
    width: 100%;
    height: 100%;
    align-items: center;
    display: flex;
    justify-content: center;
    filter: blur(15px);
  }

  .labelStuff,
  .first-card {
    position: absolute;
  }


  .first-card {
    width: 100%;
    height: 100%;
    display: flex;
  }


  .logoWithin {
    height: 400px;
    width: 400px;
    display: block;
  }

  .logoText {
    font-size: 5em !important;
    font-family: "Auriol LT Std";
    margin-top: 0;
    text-align: center;
    color: white;
  }

  .bigLogo {
    text-align: center;
  }

  .bigLogo img {
    margin-top: 20px;
    height: 270px;
    width: 270px;
  }

  @media (max-width: 400px) {
    .bigLogo img {
      margin-top: 50px;
      height: calc(50vw);
      width: calc(50vw);
    }
  }

  .welcomeCard {
    background-color: rgba(0, 85, 212, 0.8) !important;
    color: white;
    width: 270px;
    margin: auto;
  }



  .resultContainer {
    height: 550px;
    font-family: Roboto, "Helvetica Neue", sans-serif;

  }

  .welcomeCard {
    background-color: #0055D4;
    color: white;
  }

  .item {
    min-height: 50px;
    min-width: 300px;
    margin: 10px;

  }

  .logoText {
    font-family: 'Auriol LT Std';
    font-size: 3em !important;
  }

  .actions {
    width: 100%;
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }

  .actions1 {
    width: 100%;
    position: relative;
    padding-left: 0;
    padding-right: 0;
  }

  .background1 {
    /* background-color: red; */
    filter: blur(5px);
    position: absolute;
    z-index: 0;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .foreground1 {
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    margin-left: 0;
    margin-right: 0;
    background-color: rgba(255,255,255,0.1);
  }

  .card__actions > *, .card__actions .btn {
    margin: 0 !important;
  }

  .v-card__text {
    padding-bottom: 0;
    padding-top: 0;
  }

  .logoText {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .v-card__text .paraLink {
    margin-top: 26px !important;
  }




  p :nth-of-type(2){
    padding-bottom: 0;
  }

  .background {
    /* background-color: white; */
    filter: blur(5px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 35px;
  }

  .foreground {
    height: 36px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    margin-left: 0;
    margin-right: 0;
    background-color: rgba(255,255,255,0.1);
  }

  .background, .foreground {
    width: 100%;
    position: absolute;
  }

  .title {
    font-size: 1em !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/FirstPage.vue